import React, {
  useEffect,
  useState,
  useReducer,
  useContext,
  useRef
} from 'react'
import { QlikReportTab } from './QlikReportTab'
import { useQlikApp } from './QlikApp'
import { Loader } from './Loader'
import { QlikUIContext } from '../QlikUIContext'
import { Tabs, Tab, IconButton, useTheme, makeStyles } from '@material-ui/core'
import { stylesMui } from './styles/qlikReport.styles'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faUndo,
  faFilter,
  faTimes,
  faRedo,
  faSyncAlt,
  faPen
} from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from 'react-i18next'

import styles from './css/qlik-report-styles.css'

function reportReducer(state, action) {
  switch (action.type) {
    case 'unmount': {
      return {
        ...state,
        showBack: false,
        showForward: false,
        showReload: false,
        showReloadAll: false,
        showLastReloadTime: false
      }
    }
    case 'manage': {
      return {
        ...state,
        showBack: action.payload.backCount >= 1 && action.payload.length > 0,
        showForward:
          action.payload.forwardCount >= 1 && action.payload.length > 0
      }
    }

    case 'reload': {
      const isReload = action.payload.qvdLoader && action.payload.report.Reload
      return {
        ...state,
        showReload: isReload,
        showReloadAll: isReload ? false : action.payload.report.Reload,
        //showLastReloadTime: action.payload.report.Active || action.payload.report.Type === 1
        showLastReloadTime: true
      }
    }
    default:
      return state
  }
}

const initialState = {
  showBack: false,
  showForward: false,
  showReload: false,
  showReloadAll: false,
  showLastReloadTime: false
}

export const QlikReport = ({
  qlik,
  report,
  reportType,
  onEditReport,
  transformRatio,
  dimensions
}) => {
  const context = useContext(QlikUIContext)

  const [t] = useTranslation(['qlik'])

  const container = useRef()

  const [tabs, setTabs] = useState(undefined)
  const [activeTab, setActiveTab] = useState('')
  const [qAppFiltered, setqAppFiltered] = useState(false)
  const currentTheme = useTheme()
  const useStyles = makeStyles(stylesMui(currentTheme))
  const classes = useStyles()

  const [state, dispatch] = useReducer(reportReducer, initialState)
  const {
    showBack,
    showForward,
    showReload,
    showReloadAll,
    showLastReloadTime
  } = state

  const [isReloading, setIsReloading] = useState(false)

  const [
    qAppLoaded,
    qApp,
    selState,
    vMOD,
    vQVDLoader,
    lastReloadTime,
    reload,
    reloadAll,
    partialReload,
    setFilters
  ] = useQlikApp(context.client, report.AmbitId, qlik)

  useEffect(() => {
    function onDataBindHandler() {
      qApp.getList('CurrentSelections', function (reply) {
        var selections = reply.qSelectionObject
        dispatch({
          type: 'manage',
          payload: {
            forwardCount: selections.qForwardCount,
            backCount: selections.qBackCount,
            length: selections.qSelections.length
          }
        })
      })
    }

    if (qAppLoaded) {

      let f = [];
      if (report.Filters) {
          report.Filters.forEach(fi => {
            if (dimensions) {
              dimensions.filter(d => d.Dimension == fi.Dimension.Title)
                .forEach(d => f.push({Var: fi.Dimension.Description, Value: d.Value}))
            }
          });

          setFilters(f)
            .then(() => {
              setIsReloading(true);
              reloadAll()
                .then(() => {
                  setqAppFiltered(true);
                  setIsReloading(false);
                })
                .catch(function (error) {
                  console.log(error)
                  setqAppFiltered(true);
                  setIsReloading(false);
                })
               //setqAppFiltered(true)
            })
            .catch(function (error) {
              console.log(error);
              setqAppFiltered(true);
            })
      }
      else {
        setqAppFiltered(true);
      }

      selState.OnData.bind(onDataBindHandler)
      onDataBindHandler()

      dispatch({
        type: 'reload',
        payload: {
          report: report,
          qvdLoader: vQVDLoader !== '' && vMOD !== ''
        }
      })
    }

    return () => {
      dispatch({ type: 'unmount' })
    }
  }, [qAppLoaded])

  useEffect(() => {
    setTabs(
      report.Tabs.map((tab, index) => {
        let devices = []
        tab.DeviceWidgets.forEach((element) => {
          devices.push(element.Device)
        })
        let device = getActiveDevice(devices)

        return {
          id: tab.Id,
          description: tab.Description,
          widgets: tab.DeviceWidgets.find(
            (e) => e.Device.Id === device.Id
          ).Widgets.sort()
        }
      })
    )
  }, [report])

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window
    return {
      width,
      height
    }
  }

  const getActiveDevice = (devices) => {
    var orderedDevices = devices.sort(function (a, b) {
      return a.Width < b.Width ? -1 : a.Width > b.Width ? 1 : 0
    })

    var device = orderedDevices.find(
      (e) => getWindowDimensions().width <= e.Width
    )

    if (device === undefined) {
      var biggerWidthDevice = orderedDevices.reduce((acc, curr) => {
        return acc.width >= curr.width ? acc : curr
      })
      return biggerWidthDevice
    } else {
      return device
    }
  }

  const handleReload = () => {
    setIsReloading(true)
    reload()
      .then(() => {
        setIsReloading(false)
      })
      .catch(function (error) {
        console.log(error)
        setIsReloading(false)
      })
  }

  const handleReloadAll = () => {
    setIsReloading(true)
    reloadAll()
      .then(() => {
        setIsReloading(false)
      })
      .catch(function (error) {
        console.log(error)
        setIsReloading(false)
      })
  }

  const onChangeTabHandler = (event, tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab)
    }
  }

  return (
    <React.Fragment>
      {qApp && (
        <div className={classes.header}>
          {showLastReloadTime &&
            t('qlik:report.lastUpdate', {
              date: new Intl.DateTimeFormat('default', {
                dateStyle: 'short',
                timeStyle: 'medium'
              }).format(lastReloadTime)
            })}
          <div className={styles.historyButtons}>
            {showBack && (
              <IconButton
                aria-label={t('qlik:report.undo')}
                onClick={() => qApp.back()}
                size='small'
                title={t('qlik:report.undo')}
                color='primary'
              >
                <FontAwesomeIcon icon={faUndo} fixedWidth />
              </IconButton>
            )}
            {showBack && (
              <IconButton
                aria-label={t('qlik:report.clearFilter')}
                onClick={() => qApp.clearAll()}
                size='small'
                title={t('qlik:report.clearFilter')}
                color='primary'
              >
                <span className='fa-layers fa-fw'>
                  <FontAwesomeIcon icon={faFilter} fixedWidth />
                  <FontAwesomeIcon
                    icon={faTimes}
                    fixedWidth
                    inverse
                    transform='shrink-6 up-2'
                  />
                </span>
              </IconButton>
            )}
            {showForward && (
              <IconButton
                aria-label={t('qlik:report.reDo')}
                onClick={() => qApp.forward()}
                size='small'
                title={t('qlik:report.reDo')}
                color='primary'
              >
                <FontAwesomeIcon icon={faRedo} fixedWidth />
              </IconButton>
            )}
            {showReload && (
              <IconButton
                aria-label={t('qlik:report.reLoad')}
                onClick={handleReload}
                size='small'
                title={t('qlik:report.reLoad')}
                color='primary'
              >
                <FontAwesomeIcon icon={faSyncAlt} fixedWidth />
              </IconButton>
            )}
            {showReloadAll && (
              <IconButton
                aria-label={t('qlik:report.reLoadAll')}
                onClick={handleReloadAll}
                size='small'
                title={t('qlik:report.reLoadAll')}
                color='primary'
              >
                <FontAwesomeIcon icon={faSyncAlt} fixedWidth />
              </IconButton>
            )}
            <IconButton
              aria-label={t('qlik:report.edit')}
              onClick={() => onEditReport(report)}
              size='small'
              title={t('qlik:report.edit')}
              color='primary'
            >
              <FontAwesomeIcon icon={faPen} fixedWidth />
            </IconButton>
          </div>
        </div>
      )}

      {reportType == '0' && (
        <div className={styles.reports}>
          {qApp && tabs && qAppFiltered && (
            <QlikReportTab
              widgets={tabs[0].widgets}
              qApp={qApp}
              transformRatio={transformRatio}
            ></QlikReportTab>
          )}
        </div>
      )}

      {reportType !== '0' && (
        <div className={styles.tabcontent} ref={container}>
          {qApp && tabs && qAppFiltered && (
            <Tabs
              value={activeTab === '' ? tabs[0].description : activeTab}
              onChange={onChangeTabHandler}
              indicatorColor='primary'
              textColor='primary'
              className={classes.tabsRoot}
            >
              {tabs.map((tab) => {
                return (
                  <Tab
                    key={tab.id}
                    label={tab.description}
                    value={tab.description}
                  ></Tab>
                )
              })}
            </Tabs>
          )}
          {qApp &&
            qAppFiltered &&
            tabs && 
            tabs.map((tab, index) => {
              let hid =
                activeTab !== ''
                  ? activeTab !== tab.description
                  : tabs[0].description !== tab.description
              return (
                <div
                  key={tab.id}
                  role='tabpanel'
                  hidden={hid}
                  id={`simple-tabpanel-${index}`}
                  aria-labelledby={`simple-tab-${index}`}
                >
                  {!hid && (
                    <QlikReportTab
                      widgets={tab.widgets}
                      qApp={qApp}
                      transformRatio={container.current.clientWidth / 24}
                    ></QlikReportTab>
                  )}
                </div>
              )
            })}
        </div>
      )}

      {isReloading && (
        <Loader
          title={t('qlik:report.reLoad')}
          text={t('qlik:report.syncData')}
          log={{ show: false }}
        />
      )}
    </React.Fragment>
  )
}
